module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/work-type/worktype-grid/worktype-grid.component.css
// module id = ./src/app/master/work-type/worktype-grid/worktype-grid.component.css
// module chunks = main